import { render, staticRenderFns } from "./check-apply-scoring.vue?vue&type=template&id=8df8a8fc&scoped=true"
import script from "./check-apply-scoring.vue?vue&type=script&lang=js"
export * from "./check-apply-scoring.vue?vue&type=script&lang=js"
import style0 from "./check-apply-scoring.vue?vue&type=style&index=0&id=8df8a8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df8a8fc",
  null
  
)

export default component.exports